import { TFunction, useTranslation } from "@impero-com/common/utils/i18n";
import * as z from "zod";

import { accessRightSchema } from "components/form/rhfFields/rhfAccessRights";
import { ControlProgramAccessRightsInstance } from "utils/accessRights/models";

const MAX_TITLE = 255;
const MAX_DESCRIPTION = 100000;

export const CONTROL_ENTITIES_KEY = "controlEntityIds";

export const getNameSchema = (t: TFunction) =>
    z
        .string()
        .trim()
        .min(1, { error: t("Validation_Required") })
        .max(MAX_TITLE);

export const descriptionSchema = z.string().trim().max(MAX_DESCRIPTION);

export function useControlProgramViewFormSchema() {
    const { t } = useTranslation();
    return z.object({
        name: getNameSchema(t),
        description: descriptionSchema,
        running: z.boolean(),
        tagIds: z.array(z.guid()),
        responsibleId: z
            .number()
            .nullable()
            // eslint-disable-next-line zod/require-error-message
            .refine((v): boolean => v !== null, {
                message: t("Validation_Required"),
            }),
        accessRights: accessRightSchema(ControlProgramAccessRightsInstance),
        controlEntityIds: z.array(
            z.object({
                entityId: z.number(),
            })
        ),
    });
}

export type ControlProgramFormSchema = z.infer<
    ReturnType<typeof useControlProgramViewFormSchema>
>;
